export default __webpack_public_path__ + "2da14f1e049bd0dcb50f1f8cd7802a63.svg";